import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { fetchNavi, switchLang } from '../../redux/actions';
import LangWrapper from '../../components/LangWrapper';
import { fetchMenu, fetchDate } from '../../redux/actions';
//import slug from 'slug'

//import SubNav from '../../components/SubNav';

import './Header.css';
import './MobileNav.css';

class Header extends Component {
  constructor(props){
    super(props)
    this.state = {
      navigationOpen: false,
      menuOpen: false
    }
  }

  componentDidMount() {
    const locale = this.props.intl.locale;

    this.props.fetchDate();

    if (!this.props.navi) {
      this.props.fetchNavi(locale);
    }

    if (!this.props.menus.length) {
      this.props.fetchMenu(this.props.date, locale);
    }
  }

  componentDidUpdate() {
    window.scroll(0, 0);
  }

  handleNavToggle() {
    if(this.state.navigationOpen) {
      this.setState({
        navigationOpen: false
      })
    }
    else {
      // if(window.innerWidth <= 767) {
        this.setState({
          navigationOpen: true
        })
      // }
    }
  }

  handleMenu() {
    if(this.state.menuOpen) {
      this.setState({
        menuOpen: false
      })
    }
    else {
      this.setState({
        menuOpen: true
      })
    }
  }

  onSwitchLang() {
    this.props.switchLang();
    window.location.reload();
  }

  render() {
    /*const isItemValid = (item, time) => {
      return (!item.fields.validFrom || new Date(time) >= new Date(item.fields.validFrom))
        && (!item.fields.validUntil || new Date(time) < new Date(item.fields.validUntil));
    }*/
    
    const {naviItems/*, menus*/, match} = {...this.props};
    const currentSlug = match.params.slug;
    //const date = this.props.date;

    let childrenBool;

    if(naviItems) {
      naviItems.forEach((item) => {
        const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
        let isCurrent = currentSlug === mainPage.fields.slug;
        if(item.childPages) {
          item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

          if (isCurrent) {
            childrenBool = true;
          }
        }
      })
    }

    if(currentSlug === 'menu') {
      childrenBool = true;
    }

   // let children;

    return (
      <header className={"main-header"+(childrenBool?' subnav':'')+ ' ' +(this.state.navigationOpen ? 'open' : '')}>
        {this.props.location.pathname!=='/' && <NavLink to="/"><span className="logo">Boulevard</span></NavLink>}
        <nav>
          { naviItems &&
            naviItems.map((item, i) => {
              const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
              let isCurrent = currentSlug === mainPage.fields.slug;
              if(item.childPages) {
                item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

               /* if (isCurrent) {
                  children = item.childPages;
                }*/
              }
              return false;
            })
          }
          { /*children &&
            <SubNav
              items={children.map(item => ({
                link: `/${item.fields.slug}`,
                hidden: false,
                title: item.fields.title,
              })
            )} />
          */}

          { /*this.props.location.pathname.indexOf('menu')>=0 &&
            <SubNav
              currentPath={this.props.location.pathname}
              items={menus.map(item => {
                let link = `/menu/${slug(item.fields.title.toLowerCase())}`;
                let parent = link;

                if(item.fields.children) {
                  const children = item.fields.children.filter(category => isItemValid(category, date));

                  if(children) {
                    link = `${link}/${slug(children[0].fields.title.toLowerCase())}`;
                  }
                }
                return(
                {
                parent: parent,
                link: link,
                hidden: !item.fields.showInNavigation,
                title: item.fields.title,
              })}
            )} />
          */}
        </nav>
        
        <Link to="/reservation" className="reservation">{this.props.intl.messages["general.bookTable"]}</Link>
        <Link to="/lahjakortti" className="reservation gifts">{this.props.intl.messages["general.giftBtn"]}</Link>

        <LangWrapper onSwitch={() => this.onSwitchLang()} />

        <div className="header-some">
        <a href="https://www.facebook.com/boulevardhelsinki/" className="facebook" target="_blank" rel="noopener noreferrer">Facebook</a>
          <a href="https://www.instagram.com/boulevardhelsinki/" className="instagram" target="_blank" rel="noopener noreferrer">Instagram</a>
        </div>

        <span className="nav-toggle" onClick={this.handleNavToggle.bind(this)}><span /><span /><span /></span>

        <nav className={'mobile-nav '+(this.state.navigationOpen ? 'open' : '')}>
          <span className="close" onClick={this.handleNavToggle.bind(this)} />
          
          <LangWrapper onSwitch={() => this.onSwitchLang()} />

          {/*<NavLink to="/" activeClassName="active" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["header.home"]}</NavLink>*/}
          { naviItems &&
            naviItems.map((item, i) => {
              const mainPage = item.mainPage || (item.childPages ? item.childPages[0] : null);
              let isCurrent = currentSlug === mainPage.fields.slug;
            //  let children;
              if(item.childPages) {
                item.childPages.map(child => isCurrent = isCurrent || currentSlug === child.fields.slug);

               /* if (isCurrent) {
                  children = item.childPages;
                }*/
              }

              return (
                <span key={`navilink_${i}`}>
                  <NavLink to={`/${mainPage.fields.slug}`} activeClassName="active" onClick={this.handleNavToggle.bind(this)}>
                    {item.label}
                  </NavLink>
                  { /*children &&
                    <SubNav
                      onNav={() => this.handleNavToggle()}
                      items={children.map(item => ({
                        link: `/${item.fields.slug}`,
                        hidden: false,
                        title: item.fields.title,
                      })
                    )} />
                  }
                  {(mainPage.fields.slug === 'menu' && currentSlug === 'menu') &&
                    <SubNav
                      onNav={() => this.handleNavToggle()}
                      items={menus.map(item => {
                        let link = `/menu/${slug(item.fields.title.toLowerCase())}`;

                        if(item.fields.children) {
                          const children = item.fields.children.filter(category => isItemValid(category, date));

                          if(children) {
                            link = `${link}/${slug(children[0].fields.title.toLowerCase())}`;
                          }
                        }
                        return(
                        {
                        link: link,
                        hidden: !item.fields.showInNavigation,
                        title: item.fields.title,
                      })}
                    )} />
                  */}
                </span>
              );
            })
          }
          {/*<NavLink to="/blog" activeClassName="active" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["header.blog"]}</NavLink>*/}
          <NavLink to="/contact" activeClassName="active" onClick={this.handleNavToggle.bind(this)}><FormattedMessage id="header.contactUs" /></NavLink>
          <Link to="/reservation" className="reservation" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.bookTable"]}</Link><br />
          <Link to="/lahjakortti" className="reservation gifts" onClick={this.handleNavToggle.bind(this)}>{this.props.intl.messages["general.giftBtn"]}</Link>
        </nav>
      </header>
    );
  }
}

Header.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  naviItems: state.navi,
  menus: state.menus,
  date: state.date,
});

const mapDispatchToProps = {
  fetchNavi,
  fetchMenu,
  fetchDate,
  switchLang
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(Header)));



// WEBPACK FOOTER //
// ./src/containers/Header/Header.js